import React, {useEffect, useRef, useState} from 'react';
import { Controller, SubmitHandler, useForm } from 'react-hook-form';
import {
    Button,
    TextField,
    CircularProgress, DialogTitle, DialogActions, Dialog, DialogContent, Autocomplete, Stack
} from '@mui/material';
import {Box, Grid, ListItemText, MenuItem, Typography} from "@mui/material";
import {yupResolver} from "@hookform/resolvers/yup";
import * as Yup from "yup";
import {DipendentiList, PrevTesta, PrevTestaForm, VMPrevList} from "./types";
import {
    useGetDipendentiList,
    useGetClientiDTO,
    useUpdatePrevTesta,
    useGetPrevTestaDTObyPrev, useGetVMPrev, useDuplicaPrev,
} from "./Services";
import PreventiviEditSE from "./PreventiviEditSE";
import PreventiviEditCE from "./PreventiviEditCE";
import { fnCalcolaPM } from "./Services";
import { useCreatePrevCustElem, useUpdatePrevCustElem, useGetPrevCustElemByPrev } from "./ServicesCE";

interface PreventiviEditProps {
  onClose: () => void;
  idprevtestaprop: number;
  coddittaprop: number;
}

const PreventiviEdit: React.FC<PreventiviEditProps> = ({ onClose, idprevtestaprop,coddittaprop }) => {
   const validationSchema = Yup.object().shape({
        id: Yup.number(),
        idcli: Yup.string().nullable(),
        codprev: Yup.string().nullable(),
        codcli : Yup.number().nullable(),
        codditta :Yup.number(),
        note :Yup.string().nullable(),
        desprev :Yup.string().nullable(),
        numord :Yup.string().nullable(),
        // codref :Yup.string(),
        flgtemp :Yup.string().nullable(),
        codprog :Yup.string().nullable(),
        flgval :Yup.string().nullable(),
        idvmprev :Yup.number().nullable(),
        // numtot :Yup.number(),
        dataprev: Yup.date()
                        .nullable()
                        .transform((value, originalValue) => {
                            if (originalValue === "") {
                                return undefined; // Convert empty string to null
                            }
                            return value;
                        })
                        .typeError("Data preventivo deve essere una data valida"),
    });

    const { data: { results = [], count } = {}, isError: isLoadingPrevTestaDTOError, isFetching: isFetchingPrevTestaDTO, isLoading: isLoadingPrevTestaDTO } = useGetPrevTestaDTObyPrev(idprevtestaprop);
    const { mutateAsync: updatePrevTesta, isPending: isUpdatingPrevTesta } = useUpdatePrevTesta();
    const { watch, register, control, setValue, handleSubmit, reset, formState: { errors }} = useForm({resolver: yupResolver(validationSchema)});



    // console.log(errors);

    const [idcli, setIdCli] = useState('0');
    const [codditta, setCodDitta] = useState(coddittaprop);
    const [coddip, setCodDip] = useState('');
    const [flgtemp, setFlgTemp] = useState('');
    const [flgval, setFlgVal] = useState('');
    const [dataprev, setDataPrev] = useState('');
    const [numtot, setNumTot] = useState(0); // State to store numtot received from PreventiviEditSE


    const [ceKey, setCeKey] = useState(0);


  const { data: ClientiDTOApiResponse, refetch: refetchClienti } = useGetClientiDTO(codditta);

  const { data: DipendentiListApiResponse, refetch: refetchDipendentiList } = useGetDipendentiList(codditta);

const {  data: { results: ceRows = [] } = {},  refetch: refetchCeRows} = useGetPrevCustElemByPrev(  { pageIndex: 0, pageSize: 1000 },  [],  '',  [],  idprevtestaprop);






   const role = localStorage.getItem('keyrole') || '';

    const [idvmprev, setIdVMPrev] = useState(0);
    const {  data: VMPrevApiResponse } = useGetVMPrev();


   let impcoddip = localStorage.getItem('impcoddip') || 'NN';

   let isAdmin = false;
   let isCodDipEnabled = false;

   if (role.includes('TimeReportPreventivi')) {
                                // setCodDip((impcoddip === 'NN' || impcoddip === '') ? '' : impcoddip);
                                isAdmin = true;
                                isCodDipEnabled = true;
                            } ;


       useEffect(() => {
    if (results.length > 0) {
        reset(results[0]);
        if (idcli !== results[0].idcli) setIdCli(results[0].idcli || '');
        if (coddip !== results[0].coddip) setCodDip(results[0].coddip || '');
        if (codditta !== results[0].codditta) setCodDitta(results[0].codditta || 0);
        if (numtot !== results[0].numtot) setNumTot(results[0].numtot || 0);
        if (flgtemp !== results[0].flgtemp) setFlgTemp(results[0].flgtemp || 'N');
        if (idvmprev !== results[0].idvmprev) setIdVMPrev(results[0].idvmprev || 0);
        }
    }, [results, reset]);

   const prevCodDitta = useRef<number | null>(null);
   useEffect(() => {
    if (prevCodDitta.current !== codditta) {
        setIdCli('');  // Use null instead of '0' to avoid invalid values
        refetchClienti();
        prevCodDitta.current = codditta;
    }
}, [codditta, refetchClienti]);

const { mutateAsync: createPrevCustElem } = useCreatePrevCustElem();
const { mutateAsync: updatePrevCustElem } = useUpdatePrevCustElem();

const handleCalcolaPM = async () => {
  try {
    const res = await fnCalcolaPM({ idprev: idprevtestaprop });
    const pmValue = res.pm;

    const existingPM = ceRows.find(
      (r) => r.codmodcust === 'PRJ01' && r.codareacust === 'PRJ'
    );

    if (existingPM) {
      await updatePrevCustElem({
        ...existingPM,
        numtot: pmValue,
        numanalisi: 0,
        numconf: 0,
        numform: pmValue,
      });
    } else {
      await createPrevCustElem({
        id: '0',
        idprevtesta: idprevtestaprop,
        codareacust: 'PRJ',
        desareacust: 'Project Management',
        codnodoareacust: '01.660',
        seqareacust: 66000,
        codmodcust: 'PRJ01',
        desmodcust: 'Project Management',
        codnodomodcust: '01.660.001',
        seqmodcust: 66001,
        numanalisi: pmValue,
        numconf: 0,
        numform: 0,
        numtot: pmValue,
        numprep: 0,
        note: '',
        flgprevcons: 'P',

      });
    }

    // ✅ FORCE CHILD RELOAD
    setCeKey(prev => prev + 1);

  } catch (err) {
    console.error("Errore calcolo PM", err);
  }
};

    const clickedButtonRef = useRef<string | null>(null);
    const handleButtonClick = (buttonId: string) => {
        clickedButtonRef.current = buttonId;
    };


    const onSubmit: SubmitHandler<PrevTesta> = async (data) => {

        if (clickedButtonRef.current === 'save') {
            await updatePrevTesta(data);
            onClose();
        }
    };

    const handleClose = () => {
        onClose();
    };

    const handleSelection = (setter: (value: any) => void, fieldName: any, value: any) => {
    if (value) {
         setValue(fieldName, value);
         setter(value);
        }

    };

    return (

        <Dialog onClose={onClose} open fullWidth={true} maxWidth="xl">
            <form onSubmit={handleSubmit(onSubmit)}>

                <DialogContent>
           <Stack direction="row" alignItems="center" sx={{ width: '100%' }}>

  {/* LEFT */}
  <Typography variant="h5" sx={{ flex: 1 }}>
    Modifica Preventivo
  </Typography>



  {/* RIGHT */}
  <Stack direction="row" spacing={1} sx={{ flex: 1, justifyContent: 'flex-end' }}>
    <Button variant="contained" onClick={handleClose} color="error">
      CHIUDI
    </Button>
    <Button
      id="save"
      type="submit"
      color="primary"
      variant="contained"
      onClick={() => handleButtonClick('save')}
      disabled={isUpdatingPrevTesta}
      startIcon={
        isUpdatingPrevTesta ? <CircularProgress color="inherit" size={25} /> : null
      }
    >
      SALVA
    </Button>
  </Stack>

</Stack>
                </DialogContent>
                <DialogContent>
                 <Stack spacing={2} direction="column" alignItems="flex-start">
                    <Stack direction="row" spacing={2}    alignItems="flex-start" sx={{width: '100%'}}>
                       <TextField
                            sx={{ width: '20%' }}
                            id="dataprev"
                            type="date"
                            label="Data"
                            fullWidth
                            margin="dense"
                            {...register('dataprev')}
                            onChange={(e) => setDataPrev(e.target.value)}
                        />
                        <TextField
                            sx={{ width: '10%' }}
                            id="id"
                            label="Id"
                            fullWidth
                            margin="dense"
                            {...register('id')}
                            error={!!errors.id}
                            disabled
                        />
                        <TextField
                            sx={{ width: '50%' }}
                            id="desprev"
                            label="Preventivo"
                            fullWidth
                            margin="dense"
                            {...register('desprev')}
                            error={!!errors.desprev}
                        />

                    <Autocomplete
                                sx={{
    width: "30%",
    alignSelf: "stretch",
    "& .MuiFormControl-root": {
      marginTop: 0,
    },
    "& .MuiOutlinedInput-root": {
      height: 56,
    },
  }}
                              fullWidth
                              disablePortal
                              id="coddip"
                              options={DipendentiListApiResponse?.results ?? []}
                              value={
                                DipendentiListApiResponse?.results.find(
                                  (item) => item.coddip === coddip
                                ) || null
                              }
                              getOptionLabel={(option) => option.label}
                              onChange={(event, value) => {
                                handleSelection(setCodDip, "coddip", value?.coddip ?? "");
                              }}
                              disabled={!isCodDipEnabled}
                              renderInput={(params) => (
    <TextField
      {...params}
      label="Referente"
      margin="dense"
      fullWidth
    />
  )}
                            />

                        <TextField
                            sx={{ width: '12%' }}
                            select
                            id="codditta"
                            value={codditta}
                            label="Ditta"
                            fullWidth
                            margin="dense"
                            {...register('codditta')}
                            error={!!errors.codditta}
                            onChange={(e) => setCodDitta(Number(e.target.value))}
                        >
                            <MenuItem key={2} value={2}>BS</MenuItem>
                            <MenuItem key={1} value={1}>IN4IT</MenuItem>
                        </TextField>
                        <Autocomplete
                                                            sx={{
    width: "30%",
    alignSelf: "stretch",
    "& .MuiFormControl-root": {
      marginTop: 0,
    },
    "& .MuiOutlinedInput-root": {
      height: 56,
    },
  }}
                            disablePortal
                            id="idcli"
                            value={ClientiDTOApiResponse?.results.find(item => item.idcli === idcli) || null}
                            options={ClientiDTOApiResponse?.results ?? []}
                            onChange={(event, value) => {
                                handleSelection(setIdCli, 'idcli', value?.idcli)}}
                            renderInput={(params) => (
                                <TextField {...params} margin="dense"   fullWidth label="Cliente" />
                            )}
                        />
                        <TextField
                            sx={{ width: '10%' }}
                            id="numord"
                            label="Num.Ord."
                            fullWidth
                            margin="dense"
                            {...register('numord')}
                            error={!!errors.numord}
                        />
                        <TextField
                            sx={{ width: '10%'  }}
                            id="codprog"
                            label="Cod.Prog"
                            fullWidth
                            margin="dense"
                            {...register('codprog')}
                            error={!!errors.codprog}
                        />
                   </Stack>
                     <Stack direction="row" spacing={2} sx={{width: '100%'}}>
                          <TextField
                            sx={{ width: '70%' }}
                            id="note"
                            label="Note"
                            fullWidth
                            margin="dense"
                            {...register('note')}
                            error={!!errors.note}
                          />
                          <Typography variant="body2" color="error">
                            {errors.note?.message}
                          </Typography>

                {/*<Autocomplete<VMPrevList>*/}
                {/*     sx={{ width: '20%' }}*/}
                {/*      options={VMPrevApiResponse?.results ?? []}*/}
                {/*      value={*/}
                {/*        VMPrevApiResponse?.results.find(*/}
                {/*          (item) => item.idvmprev === idvmprev*/}
                {/*        ) || null*/}
                {/*      }*/}
                {/*      getOptionLabel={(option) => option.label}*/}
                {/*      isOptionEqualToValue={(option, value) =>*/}
                {/*        option.idvmprev === value.idvmprev*/}
                {/*      }*/}
                {/*      onChange={(event, value) => {*/}
                {/*                handleSelection(setIdVMPrev, 'idvmprev', value?.idvmprev)}}*/}
                {/*      renderInput={(params) => (*/}
                {/*        <TextField {...params} label="Seleziona VM" />*/}
                {/*      )}*/}
                {/*    />*/}

                          <TextField
                            sx={{width: '10%', '& .MuiInputBase-input.Mui-disabled': { color: 'red' },}}
                            id="numtot"
                            value={numtot}
                            label="Totale ORE"
                            fullWidth
                            margin="dense"
                            /*{...register('numtot')}*/
                            // error={!!errors.numtot}
                            disabled
                          />
                          <Typography variant="body2" color="error">
                            {/*{errors.numtot?.message}*/}
                          </Typography>

                       {isAdmin && (
                              <TextField
                                sx={{ width: '10%' }}
                                select
                                id="flgtemp"
                                value={flgtemp}
                                label="Flag Temp"
                                fullWidth
                                margin="dense"
                                {...register('flgtemp')}
                                error={!!errors.flgtemp}
                                onChange={(e) => setFlgTemp(e.target.value)}
                              >
                                      <MenuItem key={'Y'} value={'Y'}>Y</MenuItem>
                                      <MenuItem key={'N'} value={'N'}>N</MenuItem>

                              </TextField>
                            )}
                          {isAdmin && (
                              <TextField
                                sx={{ width: '10%' }}
                                select
                                id="flgval"
                                value={flgtemp}
                                label="Flag Val"
                                fullWidth
                                margin="dense"
                                {...register('flgval')}
                                error={!!errors.flgval}
                                onChange={(e) => setFlgVal(e.target.value)}
                              >
                                      <MenuItem key={'Y'} value={'Y'}>Y</MenuItem>
                                      <MenuItem key={'N'} value={'N'}>N</MenuItem>

                              </TextField>
                            )}
                         </Stack>
                   </Stack>
                 </DialogContent>

                 <DialogContent sx={{ mt: 0.2, mb: 0.2, pt: 0.2, pb: 0.2 }}>

 <Box sx={{ display: 'flex', alignItems: 'center', position: 'relative', mb: 1 }}>

  {/* LEFT TITLE */}
  <Typography variant="h6">
    Service Elements
  </Typography>

  {/* CENTER BUTTON */}
  <Box
    sx={{
      position: 'absolute',
      left: '50%',
      transform: 'translateX(-50%)',
    }}
  >
    <Button
      variant="contained"
      color="primary"
      onClick={handleCalcolaPM}
    >
      CALCOLA PM
    </Button>
  </Box>

</Box>

<PreventiviEditSE idprevprop={idprevtestaprop} />

</DialogContent>
                  <DialogContent sx={{ mt: 0.5, mb: 0.5, pt: 0.5, pb: 0.5 }}>
                    <Typography variant="h6">Attività Aggiuntive</Typography>
                    <PreventiviEditCE key={ceKey} idprevprop={idprevtestaprop} />
                  </DialogContent>
            </form>
        </Dialog>
    );
};

export default PreventiviEdit;
